const PAYMENT_METHOD_CODES = ['CASH', 'ONLINE', 'CREDIT_CARD_AT_DOORSTEP', 'EC_AT_DOORSTEP', 'MEAL_VOUCHER', 'EC_TERMINAL', 'GIFT_COUPON', 'QR_CODE', 'INVOICE', 'TAP_TO_PAY', 'ROOM_CHARGE']

const getPaymentMethodName = (method, t, lng) => PAYMENT_METHOD_CODES.includes(method) ? t(`Filter.payment.${method}`, lng) : method

export const getPaymentMethodNames = (methods, t, lng) => [...new Set(methods || [])]
	.map(method => getPaymentMethodName(method, t, lng))
	.join(', ')
